<div class="layout-wrapper" [ngClass]="{'layout-menu-horizontal':
    currentUser.menuMode === 'horizontal',
    'layout-menu-popup': currentUser.menuMode === 'popup',
    'layout-menu-overlay': currentUser.menuMode === 'overlay',
    'layout-menu-static': currentUser.menuMode === 'static',
    'layout-menu-static-inactive': (currentUser.menuMode == 'static' &&
    menuActive === false),
    'p-input-filled': currentUser.inputStyle === 'filled', 'p-ripple-disabled':
    !ripple}" (click)="onLayoutClick()">

    <app-topbar></app-topbar>

    <div class="layout-main">
        <div class="layout-content">
            <router-outlet></router-outlet>
        </div>
    </div>

    <app-chatbot-modal [display]="displayChatBox" [chatBotInitializationData]="chatBotInitializationData"
    (onCancel)="onCancelChatBotDialog($event)" [moduleName]="chatbotModule" *ngIf="displayChatBox"
    [chatbotModules]="chatbotModules"></app-chatbot-modal>

   <app-user-preference [showSetting]="false"></app-user-preference>
    <!-- <app-config></app-config> -->
</div>
<ng-container *ngIf="isShowSpinner">
    <div class="loader">
        <div class="splash-screen">
            <div class="splash-loader">
                <div class="splash-cube1"></div>
                <div class="splash-cube2"></div>
                <div class="splash-cube4"></div>
                <div class="splash-cube3"></div>
            </div>
        </div>
    </div>
</ng-container>

<app-details-task *ngIf="displayEditViewTask" [headerTitle]="'Show Task Details'"
[display]="displayEditViewTask" [selectedTaskId]="selectedTaskId"
(cancelClicked)="cancelClicked($event)" (onUpdateComplete)="onUpdateComplete($event)">
</app-details-task>

<app-approval-details *ngIf="displayViewApproval" [approvalActivityInfo]="approvalActivityInfo"  [displayViewApproval]="displayViewApproval"
    (cancelClick)="displayViewApproval=false">
</app-approval-details>
<ng-container *ngIf="displayCommentDetailPopup">
    <app-workbook-comment-details [displayCommentDetailPopup]="displayCommentDetailPopup"
      [wbParentComment]="selectedParentComment" [workbookId]="workbookId" [rowNumber]="rowNumber"
      [fromNotification]="true"
      (hideCommentDetailsPopup)="hideCommentDetails()">
    </app-workbook-comment-details>
  </ng-container>

<p-sidebar #Usermenubar (onHide)="Usermenubar.destroyModal()" [(visible)]="displayDashboard" position="right" [style]="{width:'25em'}">
    <h2 style="font-weight:normal">Dashboard Widgets</h2>
    <p-tabView *ngIf="displayDashboard" class="dashboardWidgets">
        <p-tabPanel *ngFor="let d of dashboardWidgets; let i= index" header="{{d.name}}" [selected]="i == 0">
            <p-accordion>
                <ng-container *ngFor="let m of d.modules">
                    <p-accordionTab *ngIf="m.name != 'SavedSearch'" header="{{m.name}}">
                        <ng-container *ngIf="displayDashboard" [ngSwitch]="m?.chartType">
                            <div *ngFor="let item of m.items" class="widgetDisplayCss">
                                <div (click)="addDashboardContent(item,m.widgetType)">
                                    <div>{{item.widgetTitle}}</div>
                                </div>
                            </div>
                        </ng-container>
                    </p-accordionTab>
                </ng-container>
            </p-accordion>
        </p-tabPanel>
    </p-tabView>
</p-sidebar>
<p-sidebar #Notificationbar (onHide)="displayAlerts=false;Notificationbar.destroyModal();" [(visible)]="displayAlerts" position="right" [baseZIndex]="10000" [style]="{width:'25em'}" [blockScroll]="true" [showCloseIcon]="false">
    <div class="p-d-flex p-jc-between">
        <h2 style="font-weight:normal">Notifications</h2>
        <button pButton pRipple (click)="displayAlerts=false;Notificationbar.destroyModal();"
        class="p-button-text p-button-rounded p-pt-0" icon="pi pi-times"></button>
    </div>
    <app-notifications></app-notifications>
</p-sidebar>

<p-dialog header="Notification Detail" [(visible)]="displayNote" [style]="{width: '650px'}" [baseZIndex]="10000">
    <div class="header p-d-flex p-jc-between">
        <h5 *ngIf="selectedNotification">{{selectedNotification.lionO360_Object ? selectedNotification.lionO360_Object.name : 'No Module Name'}}</h5>
        <span *ngIf="selectedNotification?.lionO360_Object" pTooltip="View Details"
        tooltipPosition="top"  (click)="openNotification(selectedNotification)" class="btnBars" [tooltipOptions]="{
            showDelay: 50,
            hideDelay: 50,
            positionStyle: 'fixed',
            appendTo: 'body'
          }">
            <i class="fa fa-external-link" aria-hidden="true" style="font-size: 20px;"></i>
        </span>
    </div>
    <div class="card">
        <h5 *ngIf="selectedNotification?.objectTaskValue">Task ID :{{selectedNotification?.objectTaskValue}}</h5>
        <div class="p-d-flex p-jc-between">
            <h5 *ngIf="selectedNotification">{{selectedNotification.name}}</h5>
            <p *ngIf="selectedNotification">
                    {{selectedNotification.createdDate | localDate:'MM/DD/YYYY | h:mm a' }}
            </p>
        </div>
        <p *ngIf="selectedNotification"><span [innerHTML]= selectedNotification?.description></span></p>
    </div>
    <ng-template pTemplate="footer">
        <button pButton pRipple type="button" (click)="displayNote=false" label="Close" class="p-button-secondary"></button>
    </ng-template>
</p-dialog>


<p-toast position="top-right" [baseZIndex]="1000000"></p-toast>
<p-toast position="top-right" [baseZIndex]="1000000" [style]="{'white-space': 'pre-line'}" key="notificationMsg"></p-toast>
<p-confirmDialog key="confirm-signout" [style]="{width: '20vw'}" [baseZIndex]="1000000"></p-confirmDialog>

<p-dialog  [modal]="true" [(visible)]="isShowCookie" [style]="{width: '30vw'}" [closable]="false">
<ng-template pTemplate="header">
    <div style="display: flex; justify-content: space-between; width: 100%;">
        <h5 class="p-mb-0">
            Cookie Notice
        </h5>
        <!-- <button pButton pRipple (click)="denyCookie()" class="p-button-text p-button-rounded p-pt-0" icon="pi pi-times"></button> -->
    </div>
</ng-template>
    <p>We use cookies on our website to see how you interact with it. By accepting, you agree to our use of such cookies. We use different cookies to operate our website, analyse the use of the website, improve the performance of our website and display suitable advertisements that might be relevant to you.</p>
    <div class="p-d-flex">
        <button pButton pRipple type="button" label="Preferences" (click)="openCookieSetting()"
        class="p-button-outlined p-button-rounded p-mx-1"></button>
        <button pButton pRipple type="button" label="Only Required Cookie" (click)="cookieAcceptance(false)"
        class="p-button-secondary p-mx-1"></button>
        <button pButton pRipple type="button" label="Accept All" (click)="cookieAcceptance(true)"
        class="p-button-rounded p-mx-1"></button>
    </div>
</p-dialog>


<p-dialog [modal]="true" [(visible)]="displayCookieSetting" [style]="{width: '60vw'}" [closable]="false">
<ng-template pTemplate="header">
    <div style="display: flex; justify-content: space-between; width: 100%;">
        <h5 class="p-mb-0">
            Advanced Cookie Setting
        </h5>
        <button pButton pRipple (click)="denyCookie()" class="p-button-text p-button-rounded p-pt-0" icon="pi pi-times"></button>
    </div>
</ng-template>
    <div class="card">
        <ng-container *ngFor="let cookie of cookies">
            <p-panel header="{{cookie.name}}" class="cookie-header">
                <ng-template pTemplate="icons">
                    <p-inputSwitch [(ngModel)]="cookie.isActive" [disabled]="cookie.disabled"></p-inputSwitch>
                </ng-template>
                <p>{{cookie.description}}</p>
            </p-panel>
        </ng-container>
    </div>
    <ng-template pTemplate="footer">
      <button pButton label="Cancel" class="p-button-secondary" (click)="displayCookieSetting=false"></button>
      <button pButton label="Save" (click)="advanceCookieAcceptance(true)"></button>
    </ng-template>
</p-dialog>

@if(displayLogDetailPopup){
    <app-lion-log-details-popup [displayLogDetailPopup]="displayLogDetailPopup" [logData]="logData" [isViewMode]="false" [selectedModuleId]="selectedModuleId" (cancelLogPopupDetails)="cancelLogPopupDetails()" [selectedAccountId]="selectedAccountId">
    </app-lion-log-details-popup>
}

@if(displayNoteDetailPopup){
    <app-lion-note-details-popup [displayNoteDetailPopup]="displayNoteDetailPopup" [noteData]="noteData" [selectedModuleId]="selectedModuleId"  [selectedAccountId]="selectedAccountId" [isViewMode]="false" (cancelNotePopupDetails)="cancelNotePopupDetails()">
    </app-lion-note-details-popup>
}
